import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface SeguimientosDesplazamientosPayload {
  desplazamiento_id: number;
  fecha: string;
  ubicacion?: string | null;
  kilometraje?: number | null;
  velocidad?: number | null;
  estado_conductor: number;
  novedad?: string | null;
  accion_tomada?: string | null;
  observaciones?: string | null;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface SeguimientosDesplazamientos {
  id?: number;
  desplazamiento_id: number;
  fecha: string;
  ubicacion?: string | null;
  kilometraje?: number | null;
  velocidad?: number | null;
  estado_conductor: number;
  novedad?: string | null;
  accion_tomada?: string | null;
  observaciones?: string | null;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface SeguimientosDesplazamientosResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class SeguimientosDesplazamientosService {
  private readonly apiUrl =
    `${environment.apiUrl}/api/seguimientos_desplazamientos`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todos los seguimientos
   */
  getAll(): Observable<SeguimientosDesplazamientos[]> {
    return this.http.get<SeguimientosDesplazamientos[]>(
      this.apiUrl,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Obtener seguimiento por ID
   */
  getById(id: number): Observable<SeguimientosDesplazamientos> {
    return this.http.get<SeguimientosDesplazamientos>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Obtener seguimientos por desplazamiento
   */
  getByDesplazamiento(
    desplazamientoId: number
  ): Observable<SeguimientosDesplazamientos[]> {
    return this.http.get<SeguimientosDesplazamientos[]>(
      `${this.apiUrl}/desplazamiento/${desplazamientoId}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear seguimiento
   */
  create(
    payload: SeguimientosDesplazamientosPayload
  ): Observable<SeguimientosDesplazamientosResponse> {
    return this.http.post<SeguimientosDesplazamientosResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar seguimiento
   */
  update(
    id: number,
    payload: Partial<SeguimientosDesplazamientosPayload>
  ): Observable<SeguimientosDesplazamientosResponse> {
    return this.http.put<SeguimientosDesplazamientosResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar seguimiento
   */
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Inactivar seguimiento
   */
  inactivar(
    id: number
  ): Observable<SeguimientosDesplazamientosResponse> {
    return this.http.put<SeguimientosDesplazamientosResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Activar seguimiento
   */
  activar(
    id: number
  ): Observable<SeguimientosDesplazamientosResponse> {
    return this.http.put<SeguimientosDesplazamientosResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}
``